<div [hidden]="hideComponent">
  <div class="grid-cont grid-cont--xl">
    <div *ngIf="!hideSearchBar" class="grid-row grid-row--aic">
      <div class="grid-col grid-col--auto">
        <h1>Payments</h1>
      </div>
      <div class="grid-col"></div>

      <!--Search Bar-->
      <div class="grid-col grid-col--4">
        <input
          *ngIf="!configService.isMobile"
          type="text"
          placeholder="Search"
          class="form-input form-input--search"
          [ngModel]="searchString"
          (ngModelChange)="searchString = $event"
          data-cy="search"
        >
      </div>

<!--            <div class="grid-col grid-col&#45;&#45;auto">-->
<!--                <button type="button" class="button"><span>Filter</span>-->
<!--                  <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="button__icon">-->
<!--                  <polyline points="16 16 12 12 8 16"></polyline>-->
<!--                  <line x1="12" y1="12" x2="12" y2="21"></line>-->
<!--                  <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path>-->
<!--                  <polyline points="16 16 12 12 8 16"></polyline></svg></button>-->
<!--            </div>-->

    </div>
    <app-scheduled [searchString]="searchString"></app-scheduled>
    <div *ngIf="configService.viewPastPaymentsEnabled">
      <app-paid [searchString]="searchString" class="mt-12"></app-paid>
    </div>
    <app-tax-payments *ngIf="isRemitianTaxPaymentsEnabled$ | async" class="mt-12"></app-tax-payments>
    <app-client-portal-footer class="mt-4"></app-client-portal-footer>
  </div>
</div>
